import React from "react";

export const fwptools = {
    "/": {
        icon: "activity",
        import: "dashboard/Dashboard",
        text: "Dashboard"
    },
    "/divider-1": {
        divider: true
    },
    "/clients": {
        children: {
            "/clients/:id/batches": {
                import: "clients/BatchHistory"
            }
        },
        icon: "users",
        import: "clients/ClientList",
        rbac: "clients:read",
        text: "Clients"
    },
    "/employees": {
        icon: "user",
        import: "employees/EmployeeList",
        rbac: "employees:read",
        text: "Employees"
    },
    "/divider-2": {
        divider: true,
        rbac: ["clients:read", "employees:read"]
    },
    "/brandmonitor": {
        children: {
            "/brandmonitor/keywords": {
                icon: "key",
                import: "brandmonitor/keywords/KeywordsList",
                //rbac: 'brandmonitor:keywords:read',
                text: "Keywords"
            },
            "/brandmonitor/reports": {
                icon: "printer",
                import: "brandmonitor/reports/ReportList",
                //rbac: 'brandmonitor:reports:read',
                text: "Reports"
            },
            "/brandmonitor/imports": {
                icon: "upload",
                import: "brandmonitor/imports/ImportHistory",
                hasDownload: false,
                hasViewDetails: true,
                //rbac: 'brandmonitor:imports:read',
                menu: "Import",
                text: "Import Keywords",
                type: "importbrandmonitor"
            },
            "/divider-brandmonitor": {
                divider: true
            }
        },
        icon: "monitor",
        submenu: true,
        //     //rbac: 'brandmonitor:*',
        text: "Brand Monitor"
    },
    "/redirects": {
        children: {
            "/redirects/management": {
                icon: "link",
                import: "redirects/management/RedirectsList",
                rbac: "redirects:management:read",
                text: "Management"
            },
            "/redirects/reports": {
                icon: "printer",
                import: "redirects/reports/ReportList",
                rbac: "redirects:reports:read",
                text: "Reports"
            },
            "/redirects/imports": {
                children: {
                    "/redirects/imports/:id": {
                        rbac: "redirects:import:read"
                    }
                },
                icon: "upload",
                import: "redirects/imports/ImportHistory",
                hasDownload: false,
                hasViewDetails: true,
                rbac: "redirects:import:read",
                menu: "Import",
                text: "Import Redirects",
                type: "importredirects"
            },
            "/divider-redirects": {
                divider: true
            }
        },
        icon: "navigation",
        rbac: "redirects:*",
        submenu: true,
        text: "Redirects"
    },
    "/tools": {
        children: {
            "/tools/bulkwhois": {
                icon: "globe",
                //rbac: 'tools:bulkwhois:read',
                text: "Bulk Whois",
                type: "whois"
            },
            "/tools/dnschecker": {
                icon: "check",
                //rbac: 'tools:dnschk:read',
                text: "DNS Checker",
                type: "dnschk"
            },
            "/tools/domainprofile": {
                icon: "briefcase",
                text: "Domain Profile",
                //rbac: 'tools:domainprofile:read',
                type: "domainprofile"
            },
            "/tools/domainsearch": {
                icon: "search",
                text: "Domain Search",
                //rbac: 'tools:domainsearch:read',
                type: "domainsearch"
            },
            "/tools/hostinghistory": {
                icon: "book-open",
                text: "Hosting History",
                //rbac: 'tools:hostinghistory:read',
                type: "hostinghistory"
            },
            "/tools/reverseip": {
                icon: "chevrons-left",
                text: "Reverse IP",
                //rbac: 'tools:reverseip:read',
                type: "reverseip"
            },
            "/tools/reversens": {
                icon: "flag",
                text: "Reverse Nameserver",
                //rbac: 'tools:reversens:read',
                type: "reversens"
            },
            "/tools/reversewhois": {
                icon: "arrow-left",
                text: "Reverse Whois",
                //rbac: 'tools:reversewhois:read',
                type: "reversewhois"
            },
            "/tools/thumbnailer": {
                hasViewDetails: true,
                icon: "image",
                text: "Thumbnailer",
                //rbac: 'tools:thumbnailer:read',
                type: "thumbnailer"
            },
            "/tools/traffic": {
                icon: "truck",
                text: "Traffic",
                //rbac: 'tools:traffic:read',
                type: "traffic"
            },
            "/tools/whoishistory": {
                hasViewDetails: true,
                icon: "clock",
                text: "Whois History",
                //rbac: 'tools:whoishistory:read',
                type: "whoishistory"
            },
            "/tools/:type": {
                import: "tools/ToolsHistory"
            }
            // "/tools/:type/:id/progress": {
            //     import: "tools/loaders/batchProgress"
            // }
        },
        icon: "tool",
        rbac: "tools:*",
        submenu: true,
        text: "Tools"
    }
};